import React from 'react';

const InfoPanel = () => (
    <section>
        <div className="ses-infopanel animate slide delay-7">
            <div className="container">
                <div className="ses-infoblock-container">
                    <div className="ses-doc-header"></div>
                    <div className="ses-infoblock">The Direct Project is a federal initiative for standards-based healthcare communications, with the goal of enabling communications between all healthcare providers and patients.</div>
                </div>
                <div className="ses-infoblock-container">
                    <div className="ses-mail-header"></div>
                    <div className="ses-infoblock">Direct secure messaging empowers you to communicate with any physician or patient with a Direct email address in a way that is HIPAA and HITECH compliant. </div>
                </div>
                <div className="ses-infoblock-container">
                    <div className="ses-patient-header"></div>
                    <div className="ses-infoblock">The ability to send transition of care documents (CCDs) using Direct secure messaging. This can help you meet Meaningful Use attestation requirements and engage your patients. </div>
                </div>
            </div>
        </div>
    </section>
);

InfoPanel.defaultProps = {};

export default InfoPanel;
